<span class="{{class}} {{classInside}}">
  <ng-content></ng-content>
</span>
